import { render, staticRenderFns } from "./OTabSwitch.vue?vue&type=template&id=6b01529c&"
import script from "./OTabSwitch.vue?vue&type=script&lang=js&"
export * from "./OTabSwitch.vue?vue&type=script&lang=js&"
import style0 from "./OTabSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports